import styled from 'styled-components';
import { Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';

const { Title, Text } = Typography;

// Layout containers
export const PageContainer = styled.div`
  padding: 0 16px;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const PageTitle = styled(Title)`
  margin-bottom: 0 !important;
  color: #1F2937;
  font-size: 24px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 300px;
`;

export const ErrorContainer = styled.div`
  margin-bottom: 24px;
`;

export const BackArrow = styled(ArrowLeftOutlined)`
  font-size: 20px;
  margin-right: 12px;
  cursor: pointer;
`;

export const DetailViewContainer = styled.div`
  width: 100%;
`;

export const TableContainer = styled.div`
  margin-top: 24px;
`;

export const CustomRow = styled(Row)`
  margin: 0; /* Remove margin */
  row-gap: 16px !important; /* Add vertical space between rows */
  column-gap: 16px !important; /* Add horizontal space between columns */
`;

export const CustomCol = styled(Col)`
  padding: 0px !important; /* Reduce padding */
`;